export default __webpack_public_path__ + "static/media/ic_waig_40.71987f84.svg";